"use strict";
var ApiTransaction = (function () {
    function ApiTransaction() {
    }
    return ApiTransaction;
}());
exports.ApiTransaction = ApiTransaction;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-transaction.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-transaction.model.js